export const DEFAULT_DOWNLOAD_FILE_NAME = 'qts-files';
export const XLSX_FILE_DOWNLOAD_DETAILS = {
    fileType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    fileExtension: '.xlsx',
};
